import { Component, OnInit } from '@angular/core';
import { DocumentoService } from 'src/app/service/documento/documento.service';
import { SecurityService } from 'src/app/service/security/security.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  label_documentos=environment.LABEL_DOCUMENTOS;
  label_operaciones=environment.LABEL_OPERACIONES;
  label_cotizaciones=environment.LABEL_COTIZACIONES;
  collapse: boolean = false;
  usuario:any;
  loading: boolean;
  adqMenu:boolean;
  provMenu:boolean;
  avatar:any;
  prov:any;
  foto : any;
  adq:any;
  listCodigo:any;
  constructor(private negociabesService: DocumentoService,private securityService:SecurityService) {

    this.usuario = JSON.parse(sessionStorage.getItem("UserActive"));
    this.prov = JSON.parse(sessionStorage.getItem("ProvActive"));
    this.adq = JSON.parse(sessionStorage.getItem("AdqActive"));
    this.foto = JSON.parse(sessionStorage.getItem("uploadFoto"));

    if(this.foto == null ){
      this.foto = this.usuario.Imagen;
    }

    if(this.prov != null){
      this.provMenu = true;
      this.negociabesService.provSwicht = true;
    }
    if(this.adq != null){
      this.adqMenu = true;
      this.negociabesService.adqSwicht = true;
    }
  }

  ngOnInit() {


    //this.avatar = 'http://drive.google.com/uc?export=view&id='+ JSON.parse(sessionStorage.getItem("Foto"));
    this.ListarCodigo();
  }
  
  ListarCodigo(){
     this.securityService.ListarCodigo(this.usuario.id_user).subscribe(
       res => {
         this.listCodigo=res;
       },
       err => {});
   }
}
